import { t } from "@lingui/macro";
import { I18n } from "@lingui/core";

import { FieldName } from "..";

export default (i18n: I18n) => ({
  local: [
    {
      name: FieldName.branchCode,
      label: "Transit number",
      placeholder: `${i18n._(
        t({ id: "placeholder.example", message: "e.g." })
      )} 00063`,
      instructions: i18n._(
        t({
          id: "fields-config.branch-code.instructions",
          message: "Branch code",
        })
      ),
    },
    {
      name: FieldName.bankCode,
      label: "Institution number",
      placeholder: `${i18n._(
        t({ id: "placeholder.example", message: "e.g." })
      )} 0036`,
      instructions: i18n._(
        t({
          id: "fields-config.bank-code.instructions",
          message: "Bank code",
        })
      ),
    },
    {
      name: FieldName.accountNumber,
      label: "Account number",
      placeholder: `${i18n._(
        t({
          id: "placeholder.example",
          message: "e.g.",
        })
      )} 0123456`,
      instructions: i18n._(
        t({
          id: "fields-config.account-number.instructions",
          message: "Account number",
        })
      ),
    },
  ],
  primaryBankDetailsFields: [
    FieldName.bankCode,
    FieldName.branchCode,
    FieldName.accountNumber,
  ],
  secondaryBankDetailsField: [],
});
